import { isTransportOrder, type Order } from '#domain/Order.ts';
import type { ServiceOrderCategory } from '#domain/ServiceOrder.ts';

export const getOrderIcon = (order: Order): string => {
    if (isTransportOrder(order)) {
        return getTransportOrderIcon();
    }
    return getServiceOrderIcon(order.category);
};

export const getServiceOrderIcon = (category?: ServiceOrderCategory): string => {
    switch (category) {
        case 'charging':
            return 'icon-battery-charging';
        default:
            return 'icon-wrench';
    }
};

export const getTransportOrderIcon = (): string => 'icon-truck';
